import { createApp } from 'vue';
import Azw3ToEpubConverter from '@/Components/Azw3ToEpubConverter.vue';
import '@styles/app.css';

createApp(Azw3ToEpubConverter).mount('#azw3-to-epub-converter');
